module.exports = __webpack_public_path__ + "img/tryher-grid-percent.8ccc00ee.png";